import type { UploadedFile } from "./BankStatementUpload";
import { UploadStatus } from "./enums/uploadStatus";

export const getSuccessfulBankStatementId = (
  file: UploadedFile | undefined
): string | undefined =>
  file && file.status === UploadStatus.SUCCESS && file.document_id
    ? file.document_id
    : undefined;

export const hasBankStatementInFlight = (
  file: UploadedFile | undefined
): boolean =>
  file?.status === UploadStatus.PENDING ||
  file?.status === UploadStatus.UPLOADING;

export const hasBankStatementError = (
  file: UploadedFile | undefined
): boolean => file?.status === UploadStatus.ERROR;
